import React from 'react';

import { Button } from '@/components/ui/button';
import {
  Card, CardContent, CardHeader, CardTitle,
} from '@/components/ui/card';

const InstallInstructions = ({
  isIOS,
  isInStandaloneMode,
  isAndroid,
  handleInstallClick,
}: {
  isIOS: boolean;
  isInStandaloneMode: boolean;
  isAndroid: boolean;
  handleInstallClick: () => void;
}) => {
  return (
    <>
      {isIOS && !isInStandaloneMode && (
        <div className="w-full flex flex-col items-center gap-4 mt-9">
          <h2 className="text-2xl font-bold text-center">
            ¿Cómo instalar nuestra App?
          </h2>
          <div className="w-full flex flex-wrap flex-grow gap-4">
            {/* Instrucciones para iOS */}
            {[
              'Abrir Safari o Chrome y acceder a Powerbet.la',
              'Toca el ícono de compartir en la parte inferior de la pantalla (un cuadrado con una flecha hacia arriba).',
              'Seleccionar: Agregar a pantalla de inicio:',
              'Confirmar la instalación: Edita el nombre si lo deseas y toca: Agregar. La app se añadirá a la pantalla de inicio de tu iPhone.',
            ].map((text, index) => {
              return (
                <Card
                  key={text}
                  className="h-auto w-full flex-grow bg-sivarbet-secondary-bg text-sivarbet-text border-sivarbet-border"
                >
                  <CardHeader className="w-full text-3xl text-sivarbet-primary">
                    <CardTitle className="text-center">{index + 1}</CardTitle>
                  </CardHeader>
                  <CardContent className="h-full w-full text-center">
                    <p>{text}</p>
                  </CardContent>
                </Card>
              );
            })}
          </div>
        </div>
      )}
      {isAndroid && (
        <div className="w-full flex flex-col items-center gap-4 mt-9">
          <h2 className="text-2xl font-bold text-center">
            ¿Cómo instalar nuestra App?
          </h2>
          <Button
            className="bg-sivarbet-primary hover:bg-sivarbet-primary-hover focus:bg-sivarbet-primary-hover text-sivarbet-secondary-bg w-1/2 font-bold"
            type="submit"
            onClick={handleInstallClick}
          >
            ¡Descarga ya!
          </Button>
          <p className="text-lg text-center">
            La instalación no está disponible. Por favor, usa el navegador
            Chrome en un dispositivo Android.
          </p>
          <div className="w-full flex flex-wrap flex-grow gap-4">
            {/* Instrucciones para Android */}
            {[
              'Abre el navegador Chrome en tu dispositivo Android.',
              'Ingresa la URL de la app que deseas instalar en la barra de direcciones y navega a esa página.',
              'Una vez que la app se haya cargado completamente, toca el ícono de tres puntos verticales en la esquina superior derecha del navegador para abrir el menú de opciones.',
              'En el menú de opciones, busca y selecciona la opción que dice Agregar a la pantalla de inicio. Esta opción puede estar etiquetada de manera diferente en algunos navegadores, pero generalmente estará en este formato.',
              'Aparecerá un cuadro de diálogo solicitando confirmar el nombre de la app y la acción de agregarla a la pantalla de inicio. Puedes editar el nombre si lo deseas. Toca Agregar o Instalar para confirmar. La app se añadirá a la pantalla de inicio de tu dispositivo Android, similar a como se instala una aplicación nativa.',
            ].map((text, index) => {
              return (
                <Card
                  key={text}
                  className="h-auto w-full flex-grow bg-sivarbet-secondary-bg text-sivarbet-text border-sivarbet-border"
                >
                  <CardHeader className="w-full text-2xl text-sivarbet-primary">
                    <CardTitle className="text-center">{index + 1}</CardTitle>
                  </CardHeader>
                  <CardContent className="h-full w-full text-center">
                    <p>{text}</p>
                  </CardContent>
                </Card>
              );
            })}
          </div>
        </div>
      )}
      {!isIOS && !isAndroid && (
        <div className="w-full flex flex-col items-center gap-4 mt-9">
          <h2 className="text-3xl font-bold">¿Cómo instalar nuestra App?</h2>
          <p className="text-xl text-center">
            La instalación no está disponible. Por favor, usa el navegador
            Chrome en un dispositivo Android.
          </p>
          <div className="w-full flex flex-grow gap-4 mt-5">
            {/* Instrucciones generales */}
            {[
              'Abre el navegador Chrome en tu dispositivo Android.',
              'Ingresa la URL de la app que deseas instalar en la barra de direcciones y navega a esa página.',
              'Una vez que la app se haya cargado completamente, toca el ícono de tres puntos verticales en la esquina superior derecha del navegador para abrir el menú de opciones.',
              'En el menú de opciones, busca y selecciona la opción que dice Agregar a la pantalla de inicio. Esta opción puede estar etiquetada de manera diferente en algunos navegadores, pero generalmente estará en este formato.',
              'Aparecerá un cuadro de diálogo solicitando confirmar el nombre de la app y la acción de agregarla a la pantalla de inicio. Puedes editar el nombre si lo deseas. Toca Agregar o Instalar para confirmar. La app se añadirá a la pantalla de inicio de tu dispositivo Android, similar a como se instala una aplicación nativa.',
            ].map((text, index) => {
              return (
                <Card
                  key={text}
                  className="h-auto w-full flex-grow bg-sivarbet-secondary-bg text-sivarbet-text border-sivarbet-border"
                >
                  <CardHeader className="w-full text-3xl text-sivarbet-primary">
                    <CardTitle className="text-center">{index + 1}</CardTitle>
                  </CardHeader>
                  <CardContent className="h-full w-full text-center">
                    <p>{text}</p>
                  </CardContent>
                </Card>
              );
            })}
          </div>
        </div>
      )}
    </>
  );
};

export default InstallInstructions;
